package com.iregained.site.components.sections.product.sections

import androidx.compose.runtime.*
import com.iregained.site.components.sections.product.styles.InvertedCtaButtonStyle
import com.iregained.site.components.widgets.SharedCtaActionLink
import com.iregained.site.components.widgets.SharedCtaWidget
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Div

// UNIQUE ANIMATION: Cinematic Rise
@Composable
private fun Modifier.cinematicRise(isVisible: Boolean): Modifier {
    return this.opacity(if (isVisible) 1 else 0).translateY(if (isVisible) 0.px else 50.px).transition(
            Transition.of("opacity", 0.8.s, TransitionTimingFunction.EaseOut),
            Transition.of("transform", 0.8.s, TransitionTimingFunction.EaseOut)
        )
}

@Composable
fun ProductCtaSection(data: ProductCtaSectionData = defaultProductCtaData) {
    val targetId = data.sectionId?.takeIf { it.isNotBlank() } ?: "product-cta-section"
    var isVisible by remember { mutableStateOf(false) }

    // CMS EMPTY STATE SHIELD
    if (data.title.isNotBlank()) {
        Div(attrs = Modifier.fillMaxWidth().toAttrs {
            ref { element ->
                val observer = IntersectionObserver { entries, obs ->
                    entries.forEach {
                        if (it.isIntersecting) {
                            isVisible = true; obs.unobserve(element)
                        }
                    }
                }
                observer.observe(element)
                onDispose { observer.disconnect() }
            }
        }) {
            Box(modifier = Modifier.fillMaxWidth().cinematicRise(isVisible)) {
                SharedCtaWidget(
                    headline = data.title, description = data.subtitle, actions = {
                        if (data.buttonText.isNotBlank() && data.buttonLinkPath.isNotBlank()) {
                            SharedCtaActionLink(
                                text = data.buttonText,
                                path = data.buttonLinkPath,
                                styleModifier = InvertedCtaButtonStyle.toModifier()
                            )
                        }
                    })
            }
        }
    }
}

data class ProductCtaSectionData(
    val sectionId: String? = null,
    val title: String,
    val subtitle: String,
    val buttonText: String,
    val buttonLinkPath: String
)

val defaultProductCtaData = ProductCtaSectionData(
    sectionId = "product-cta-section",
    title = "Ready to Transform Hand Rehabilitation?",
    subtitle = "Join the leading clinics and patients using the MyHand<sup>®</sup> System to achieve measurable recovery outcomes.",
    buttonText = "Request a Demo",
    buttonLinkPath = "/contact"
)